/** Cross-cutting enums & constants shared by server and web. */
export const ROLES = ['coach', 'student'];
export const STUDIO_ROLES = ['owner', 'teacher', 'front_desk'];
export const EXERCISE_TAGS = [
    'breath',
    'resonance',
    'agility',
    'range',
    'intonation',
    'legato',
    'belting',
    'head-voice',
    'chest-voice',
    'mix',
    'articulation',
    'warm-up',
];
export const EXERCISE_LEVELS = ['beginner', 'intermediate', 'advanced'];
/**
 * How the player runs a pattern exercise: "standard" = sing along with the
 * visible scrolling target; "call_response" = ear training — each phrase
 * plays first (target hidden), the student echoes it from memory, targets are
 * revealed with the trace afterwards.
 */
export const EXERCISE_MODES = ['standard', 'call_response'];
export const NOTIFICATION_TYPES = [
    'practice_reminder',
    'take_reviewed',
    'new_message',
    'new_submission',
    'plan_assigned',
    'lesson_booked',
    'lesson_cancelled',
    'waitlist_offer',
    'digest',
    'announcement',
];
/**
 * H1 · Per-seat billing: the coach pays per active student, monthly.
 * No tiers, no caps — the first few students are free, every one beyond
 * that costs a flat monthly amount. Inviting students is never blocked.
 */
export const BILLING = {
    perStudentCentsMonthly: 290,
    freeStudents: 3,
    currency: 'EUR',
};
export function monthlyCostCents(activeStudents) {
    return Math.max(0, activeStudents - BILLING.freeStudents) * BILLING.perStudentCentsMonthly;
}
export const TAKE_REACTIONS = ['great', 'nice_progress', 'keep_going'];
/** D10 · Retention: unarchived takes kept per student unless coach-flagged. */
export const TAKE_RETENTION_CAP = 50;
/** E4 · A student is "at risk" after this many days without activity. */
export const AT_RISK_DAYS = 7;
/** Minimum age (A4). */
export const MIN_AGE_YEARS = 18;
/** H6 · EU-first VAT defaults. */
export const DEFAULT_VAT_RATE = 0.19; // Germany
export const PLATFORM_TAKE_RATE = 0.12; // I8
/**
 * J6 · No-medical-claims guardrails. All user-facing feedback strings must
 * come from (or be consistent with) this vocabulary — strictly pitch and
 * timing. Anything technique- or health-adjacent routes to the coach.
 */
export const FEEDBACK_COPY = {
    scoreExplanation: 'Your score reflects pitch accuracy and timing only.',
    askYourCoach: 'Questions about technique, strain, or how something feels? Ask your coach — that’s what they’re there for.',
    noiseWarning: 'It’s a bit noisy here — feedback works best somewhere quieter.',
    flat: 'slightly under the target pitch',
    sharp: 'slightly above the target pitch',
    onTarget: 'on target',
};
/** J2 · Latency calibration bounds (ms) considered plausible for phones. */
export const CALIBRATION_MIN_MS = 0;
export const CALIBRATION_MAX_MS = 450;
//# sourceMappingURL=types.js.map